export const APIS = {
    SIGN_IN_API: "/customer/sign-in",
    SIGN_UP_API: "/customer",
    ANALYSE_DOCUMENTS_URL: "/scan/upload",
    READY_IMPORT_DOCUMENTS_URL: "/scan/ready",
    IMPORT_DOCUMENT_URL: "/scan/import",
    LOOK_UP_CATEGORIES: "/lookup/categories",
    LOOK_UP_CUSTOMER_MERCHANTS: "/lookup/merchants",
    GET_CUSTOMER_SCAN_LIST: "/scan",
    GET_CUSTOMER_PRODUCT_LIST: "/product",
    GET_CUSTOMER_SCAN_ITEMS: "/scan/items",
    UPDATE_CUSTOMER_SCAN: "/scan/update",
}
